import { S3Creds } from '@/utils/s3';
import { QueryClient } from 'react-query';
import { GET_UPLOAD_URL, REFRESH_INTERVAL } from './useSaveProjectArtifacts';

const parseAwsDate = (input: string) => {
    return new Date(
        Date.UTC(
            parseInt(input.slice(0, 4), 10),
            parseInt(input.slice(4, 6), 10) - 1,
            parseInt(input.slice(6, 8), 10),
            parseInt(input.slice(9, 11), 10),
            parseInt(input.slice(11, 13), 10),
            parseInt(input.slice(13, 15), 10)
        )
    );
};
export const verifyCredentialsAndRefreshIfNeeded = async ({
    data,
    queryClient,
    projectId,
}: {
    data: { raw: S3Creds; thumbnail: S3Creds };
    queryClient: QueryClient;
    projectId: string;
}) => {
    const createdAt = data.raw.fields['X-Amz-Date'];
    const expires = new Date(parseAwsDate(createdAt).getTime() + REFRESH_INTERVAL);

    if (expires > new Date()) {
        return data;
    }

    await queryClient.invalidateQueries(GET_UPLOAD_URL);
    const newCreds = await queryClient.fetchQuery<{
        raw: S3Creds;
        thumbnail: S3Creds;
    }>([GET_UPLOAD_URL, projectId]);

    return newCreds;
};
